import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorSalesOrderNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ISalesOrderModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
      total: number,
      currency: {
              id: number,
                    currency: string,
            },
  }

export const ISalesOrderFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges",
    "total",
    "currency.id",
    "currency.currency"
];

export function useSalesOrderHookNae(id: number) : ISalesOrderModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorSalesOrderNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.SalesOrder.schema,
        fields: ISalesOrderFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
